import * as React from "react";
import { Tag } from "@grandvisionhq/common";
/* empty css                   */
const StoreTileTags = ({ tags }) => /* @__PURE__ */ React.createElement("div", { className: "store-tile__tags" }, tags.map((tag) => /* @__PURE__ */ React.createElement(Tag, { key: tag, label: tag })));
export {
  StoreTileTags as default
};
//# sourceMappingURL=StoreTileTags.js.map
